import { Grid2 as Grid } from '@mui/material';
import MetricCard from './MetricCard';
import MetricCardSkeleton from './MetricCardSkeleton';

export default function MetricGrid({ metricData, isLoading }) {
  if (isLoading) {
    return (
      <Grid container spacing={2} size={12}>
        {Array.from({ length: metricData.length || 3 }).map((_, index) => (
          <Grid key={index} size={{ xs: 12, md: 4 }}>
            <MetricCardSkeleton />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} size={12}>
      {metricData.map((metric, index) => (
        <Grid key={index} size={{ xs: 12, md: 4 }}>
          <MetricCard
            avatar={metric.avatar}
            title={metric.title}
            value={metric.value}
            icon={metric.icon}
            footerTitle={metric.footerTitle}
            footerDescription={metric.footerDescription}
            footerIcon={metric.footerIcon}
          />
        </Grid>
      ))}
    </Grid>
  );
}
